import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { promoCodes } from 'src/constants/promoCodes'
import { commonSubtitleText, commonTitleText } from 'src/modules/utils/constants'
import styled from 'styled-components'

export default (props) => {
  return (
    <StyledContainer>
      <USTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        title={commonTitleText.streamLiveTVSports}
        subtitle={commonSubtitleText.onAnyDevice}
        offerCode={promoCodes.mymove}
        offerBanner={{
          title: ['Special offer activated.', 'Enjoy $25 off your first 2 months from MyMove.'],
        }}
        logo={'https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-mymove.png'}
        logoHeight={'80px'}
        noIndex={true}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div``
